module.exports = __webpack_public_path__ + "img/Light.4c0953d4.png";